<div class="cr-version-bar">
  <div class="cr-version-select-wrap">
    <button type="button" class="cr-version-select" [disabled]="latest === null" [attr.aria-expanded]="menuOpen" (click)="menuOpen = !menuOpen">
      <svg class="cr-version-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="4.5" width="6" height="15" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.6"></rect><rect x="12" y="4.5" width="8.5" height="15" rx="1.8" fill="none" stroke="currentColor" stroke-width="1.6"></rect></svg>
      <span class="cr-version-select-label">{{ latest === null ? 'No version' : 'Version ' + viewing }}</span>
      <span class="cr-version-latest" *ngIf="latest !== null && viewing === latest">(latest)</span>
      <svg class="cr-version-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m7 10 5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </button>
    <div class="cr-version-menu" *ngIf="menuOpen && latest !== null" role="listbox">
      <button type="button" class="cr-version-menu-item" *ngFor="let v of versions" [class.active]="v.version === viewing" (click)="pick(v.version)">
        <span class="cr-version-menu-main">
          <span class="cr-version-menu-label">Version {{ v.version }}{{ v.version === latest ? ' (latest)' : '' }}</span>
          <span class="cr-version-source">{{ sourceLabel(v) }}</span>
          <span class="cr-version-menu-date">{{ v.createdDate | date: 'dd-MM-yyyy HH:mm' }}</span>
        </span>
        <span class="cr-version-menu-comment" *ngIf="v.comment">{{ v.comment }}</span>
      </button>
    </div>
  </div>
  <button type="button" class="cr-btn cr-btn-primary cr-version-new-btn" [title]="'Pull the current ' + languageLabel + ' content in as a new review version'" (click)="newVersion.emit()">
    <span aria-hidden="true">+</span><span>New version</span>
  </button>
</div>
